import React, { forwardRef } from 'react';
import { mergeClassNames } from '../../../../utils';
import styles from './index.module.scss';

/**
 * Wrapper for content that defines a scroll distance while being covered by a
 * component with a fixed position. Used to grow an element for scroll distance
 * that again controls the progress of scroll propagated transition.
 *
 * If 'isHidden' prop is true it will not be visible and pointer events is
 * 'none' to make sure it will not interfare with a fixed overlay in the
 * browser or a absolute positioned overlay provided as prop in this component.
 *
 * A provided overlay prop is absolute positioned on top of the scrolling
 * content to be able to display content that flows with the scrolling but that
 * is not necessarily as tall as the scrolling distance.
 */
function ScrollDistanceContainerImpl(
  { children, isHidden = false, debug = false, className = null, style = null },
  ref
) {
  return (
    <div
      ref={ref}
      className={mergeClassNames([
        styles.scrollDistance,
        isHidden && !debug ? styles.hidden : null,
        debug ? styles.debug : null,
        className,
      ])}
      style={style}
    >
      {children}
    </div>
  );
}

export const ScrollDistanceContainer = forwardRef(ScrollDistanceContainerImpl);
export * from './HeightElems';
